import { render, staticRenderFns } from "./_advice.vue?vue&type=template&id=29ce93b8&scoped=true&"
import script from "./_advice.vue?vue&type=script&lang=js&"
export * from "./_advice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ce93b8",
  null
  
)

export default component.exports